/* Secret Scenta, global behaviour.
   Everything here is enhancement: the page renders and sells without it. */
(() => {
  'use strict';

  /* ---------- reveal on scroll ---------- */
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const reveals = document.querySelectorAll('.reveal');
  if (reduceMotion || !('IntersectionObserver' in window)) {
    reveals.forEach((el) => el.classList.add('is-in'));
  } else {
    const show = (el) => {
      el.style.willChange = 'opacity, transform';
      el.classList.add('is-in');
      el.addEventListener('transitionend', () => { el.style.willChange = ''; }, { once: true });
    };
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            show(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px' }
    );
    reveals.forEach((el) => {
      // anything already on screen at load reveals immediately, the -10%
      // margin otherwise strands elements anchored to the first fold
      if (el.getBoundingClientRect().top < window.innerHeight) {
        requestAnimationFrame(() => show(el));
      } else {
        io.observe(el);
      }
    });
  }

  /* ---------- header: scrolls away, returns solid on scroll-up ---------- */
  const header = document.querySelector('[data-header]');
  if (header) {
    const releasePoint = () => header.offsetHeight + 80;
    let lastY = window.scrollY;
    let pinned = false;

    window.addEventListener(
      'scroll',
      () => {
        const y = window.scrollY;
        const goingUp = y < lastY;

        if (y <= releasePoint()) {
          if (pinned) {
            header.classList.remove('site-header--pinned');
            pinned = false;
          }
        } else if (goingUp && !pinned) {
          header.classList.add('site-header--pinned');
          pinned = true;
        } else if (!goingUp && pinned) {
          header.classList.remove('site-header--pinned');
          pinned = false;
        }
        lastY = y;
      },
      { passive: true }
    );
  }

  /* ---------- nav dropdown: hover on pointer devices, click/keys everywhere ---------- */
  document.querySelectorAll('[data-nav-dd]').forEach((dd) => {
    const summary = dd.querySelector('summary');
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      let closeTimer;
      dd.addEventListener('mouseenter', () => { clearTimeout(closeTimer); dd.open = true; });
      dd.addEventListener('mouseleave', () => { closeTimer = setTimeout(() => { dd.open = false; }, 160); });
      // hover already opened it, a click on the summary must not re-toggle it shut
      summary?.addEventListener('click', (e) => e.preventDefault());
      summary?.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          dd.open = !dd.open;
        }
      });
    }
  });
  document.addEventListener('click', (e) => {
    document.querySelectorAll('[data-nav-dd][open]').forEach((dd) => {
      if (!dd.contains(e.target)) dd.open = false;
    });
  });

  /* ---------- menu drawer ---------- */
  const drawer = document.querySelector('[data-menu-drawer]');
  document.querySelectorAll('[data-menu-open]').forEach((btn) =>
    btn.addEventListener('click', () => drawer?.showModal())
  );
  document.querySelectorAll('[data-menu-close]').forEach((btn) =>
    btn.addEventListener('click', () => drawer?.close())
  );
  drawer?.addEventListener('click', (e) => {
    if (e.target === drawer) drawer.close();
  });

  /* ---------- cart count sync ---------- */
  document.addEventListener('cart:updated', (e) => {
    const count = e.detail?.item_count;
    if (typeof count !== 'number') return;
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  });

  /* ---------- editorial typography: never leave one word stranded ---------- */
  const protectEditorialOrphans = (scope = document) => {
    const selector = [
      'h1', 'h2', 'h3',
      '.hero__sub',
      '.feature-duo__subline',
      '.feature-duo__title',
      '.feature-duo__sub',
      '.bundle__subline',
      '.bundle__saving-note',
      '.product-rail__subline',
      '.ugc__subline',
      '.pvid__subline',
      '.abnr__sub',
      '.journey-complements__subline',
      '.pdp__description'
    ].join(',');

    scope.querySelectorAll(selector).forEach((el) => {
      if (el.hasAttribute('data-ss-no-orphan')) return;

      const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      const textNodes = [];
      let node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue && node.nodeValue.trim()) textNodes.push(node);
      }

      for (let i = textNodes.length - 1; i >= 0; i -= 1) {
        const textNode = textNodes[i];
        const value = textNode.nodeValue;
        const match = value.match(/(\S+)\s+(\S+\s*)$/);
        if (!match) continue;

        textNode.nodeValue =
          value.slice(0, match.index) +
          match[1] +
          '\u00A0' +
          match[2];

        el.setAttribute('data-ss-no-orphan', '');
        break;
      }
    });
  };

  protectEditorialOrphans();
  document.addEventListener('shopify:section:load', (event) => protectEditorialOrphans(event.target));
})();
